import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AlertContext from '../../context/alerts/alertContext';
import AuthContext from '../../context/auth/authContext';

const CreateAccount = (props) => {
    // Extracting values from alert context
    const alertContext = useContext(AlertContext);
    const { alert, showAlert } = alertContext;
    // Extracting values from auth context
    const authContext = useContext(AuthContext);
    const { message, authenticated, userRegister } = authContext;
    
    // Error handling
    useEffect(() => {
        if(authenticated){
            props.history.push('/projects');
        }
        if(message){
            showAlert(message.msg, message.category);
        }
        //eslint-disable-next-line
    }, [message, authenticated, props.history]);
    
    // Set state
    const [ user, setUser ] = useState({
        name: '',
        email: '',
        password: '',
        password2: ''
    });

    const { name, email, password, password2 } = user;

    const onChange = (e) => {
        setUser({
            ...user,
            [ e.target.name ]: e.target.value
        });
    }

    const onSubmit = (e) => {
        e.preventDefault();
        // Validation to avoid void fields
        if(name.trim() === '' || email.trim() === '' || password.trim() === '' || password2.trim() === ''){
            showAlert('All fields are required, please validate', 'alerta-error');
            return;
        }
        // Validate password length minumin 6 characters
        if(password.length < 6){
            showAlert('Password must be at leas 6 characters long', 'alerta-error');
            return;
        }
        // Validation that the two passwords being the same
        if(password !== password2){
            showAlert('Passwords are not the same', 'alerta-error');
            return;
        }
        // Send the information to action for saving on database
        userRegister({
            name,
            email,
            password
        });
    }
    
    return ( 
        <div className="form-usuario">
            { alert ? ( <div className={ `alerta ${ alert.category }` }>{ alert.msg }</div> ) : null }
            <div className="contenedor-form sombra-dark">
                <h1>Create an Account</h1>
                <form
                    onSubmit={ onSubmit }
                >
                    <div className="campo-form">
                        <label htmlFor="name">Name:</label>
                        <input 
                            type="text"
                            id="name"
                            name="name"
                            placeholder="Your name"
                            value={ name }
                            onChange={ onChange }
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="email">eMail:</label>
                        <input 
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Your email"
                            value={ email }
                            onChange={ onChange }
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="password">Password:</label>
                        <input 
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Your password"
                            value={ password }
                            onChange={ onChange }
                        />
                    </div>
                    <div className="campo-form">
                        <label htmlFor="password2">Confirm Password:</label>
                        <input 
                            type="password"
                            id="password2"
                            name="password2"
                            placeholder="Confirm your Password"
                            value={ password2 }
                            onChange={ onChange }
                        />
                    </div>
                    <div className="campo-form">
                        <input 
                            type="submit"
                            className="btn btn-primario btn-block"
                            value="Create Account"
                        />
                    </div>
                </form>
                <Link to={ '/' } className="enlace-cuenta">
                    Already have an account, then Login
                </Link>
            </div>
        </div>
     );
}
 
export default CreateAccount;